import * as TYPES from './types'

/**
 * Default Projects State
 */
export const defaultState: TYPES.ProjectsState = {
  httpInProgress: false,
  httpUpdateInProgress: false,
  httpError: '',
  gnProjects: []
}

// define initial state object
const initialState: TYPES.ProjectsState = {
  httpInProgress: defaultState.httpInProgress,
  httpUpdateInProgress: defaultState.httpUpdateInProgress,
  httpError: defaultState.httpError,
  gnProjects:[]
}

// define projects reducer
export function projectsReducer (
  state = initialState,
  action: TYPES.ProjectsActionTypes
): TYPES.ProjectsState {
  switch (action.type) {
    case TYPES.PROJECTS_IN_PROGRESS: {
      return {
        ...state,
        ...{ httpInProgress: true, httpUpdateInProgress: false, httpError: '' }
      }
    }
    case TYPES.PROJECTS_UPDATE_IN_PROGRESS: {
      return {
        ...state,
        ...{ httpInProgress: false, httpUpdateInProgress: true, httpError: '' }
      }
    }
    case TYPES.PROJECTS_ERROR: {
      return {
        ...state,
        ...{ httpInProgress: false, httpUpdateInProgress: false, httpError: action.error }
      }
    }
    case TYPES.PROJECTS_RESET_DATA: {
      return {
        ...state,
        ...defaultState
      }
    }
    case TYPES.PROJECTS_GET: {
        return {
            ...state,
            ...{ gnProjects: action.payload },
            ...{ httpInProgress: false, httpUpdateInProgress: false, httpError: '' }
        }
    }
    case TYPES.PROJECTS_ADD: {
        return {
            ...state,
            ...{ gnProjects: action.payload },
            ...{ httpInProgress: false, httpUpdateInProgress: false, httpError: '' }
        }
    }
    case TYPES.PROJECTS_DELETE: {
        return {
            ...state,
            ...{ gnProjects: action.payload },
            ...{ httpInProgress: false, httpUpdateInProgress: false, httpError: '' }
        }
    }
    case TYPES.PROJECTS_UPDATE_PROJECT_DATA: {
      return {
          ...state,
          ...{ gnProjects: action.payload },
          ...{ httpInProgress: false, httpUpdateInProgress: false, httpError: '' }
      }
  }
    default:
      return state
  }
}
